import { cn } from "@/lib/utils";
import type { VideoTag } from "@/types";

interface VideoTagChipsProps {
  tags: VideoTag[];
  active?: string;
  allLabel: string;
  onChange: (slug?: string) => void;
}

/** Horizontal, scrollable on mobile, wrapping from sm up. */
export function VideoTagChips({ tags, active, allLabel, onChange }: VideoTagChipsProps) {
  const chip = (selected: boolean) =>
    cn(
      "shrink-0 rounded-full border px-3.5 py-1.5 text-sm font-medium transition-colors",
      selected ? "border-primary bg-primary text-primary-foreground" : "border-border bg-white text-foreground hover:bg-muted",
    );
  return (
    <div className="-mx-4 flex gap-2 overflow-x-auto px-4 pb-1 [scrollbar-width:none] sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0 [&::-webkit-scrollbar]:hidden">
      <button type="button" onClick={() => onChange(undefined)} className={chip(!active)}>
        {allLabel}
      </button>
      {tags.map((tag) => (
        <button key={tag.id} type="button" onClick={() => onChange(tag.slug)} className={chip(active === tag.slug)}>
          {tag.name}
          {typeof tag.count === "number" && (
            <span className={cn("ml-1.5 tabular-nums", active === tag.slug ? "text-primary-foreground/70" : "text-muted-foreground")}>
              {tag.count}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
